import { cn } from '../../utils/cn';

type Props = {
  /** A suggested action (Accept/Reject block) to attach beneath the row; undefined → render plain. */
  suggestedAction?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
};

/**
 * Wraps a care-plan item row that a suggested action targets: highlights the row and renders the
 * suggested action beneath it. With no `suggestedAction`, renders `children` unchanged so callers
 * can wrap every row unconditionally.
 */
export function SuggestedActionWrapper({ suggestedAction, className, children }: Props): React.ReactNode {
  if (!suggestedAction) return <>{children}</>;
  return (
    <div
      className={cn(
        'suggestion-pulse flex flex-col gap-1 rounded-md bg-card p-1 shadow-md dark:bg-white/10 dark:shadow-none',
        className,
      )}
    >
      {children}
      {suggestedAction}
    </div>
  );
}
